/* eslint-disable @typescript-eslint/no-unused-vars */
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { IconButton, MobileStepper, useTheme } from '@mui/material';
import { useMemo } from 'react';

import {
  BasicInfo as BasicInfoEl,
  Configurations as ConfigurationsEl,
  Schedule as ScheduleEl,
  Rules as RulesEl,
} from '.';
import { Button } from '../../../../../../components';
import { Service } from '../../../../../../entities';

export enum CommonAreasSteps {
  BasicInfo = 'BasicInfo',
  Configurations = 'Configurations',
  Schedule = 'Schedule',
  Rules = 'Rules',
}

export interface StepperContentProps {
  activeStep: number;
  service: Service;
  shouldValidate: boolean;
  file: File | null;
  handleUpload: (file: File | null) => void;
  handleSetSelectedService: (value: Partial<Service>) => void;
  validate: (value: boolean) => void;
  setShouldValidate: (value: boolean) => void;
}

export const StepperContent = ({
  activeStep,
  service,
  shouldValidate,
  file,
  handleUpload,
  handleSetSelectedService,
  validate,
  setShouldValidate,
}: StepperContentProps): JSX.Element => {
  const content = [
    <BasicInfoEl
      validate={validate}
      shouldValidate={shouldValidate}
      handleUpload={handleUpload}
      file={file}
      service={service}
      handleSetSelectedService={handleSetSelectedService}
      setShouldValidate={setShouldValidate}
    />,
    <ConfigurationsEl
      validate={validate}
      shouldValidate={shouldValidate}
      service={service}
      handleSetSelectedService={handleSetSelectedService}
      setShouldValidate={setShouldValidate}
    />,
    <ScheduleEl
      validate={validate}
      shouldValidate={shouldValidate}
      service={service}
      handleSetSelectedService={handleSetSelectedService}
      setShouldValidate={setShouldValidate}
    />,
    <RulesEl
      validate={validate}
      shouldValidate={shouldValidate}
      service={service}
      handleSetSelectedService={handleSetSelectedService}
      setShouldValidate={setShouldValidate}
    />,
  ];

  return content[activeStep];
};

interface StepperProps {
  activeStep: number;
  handleNext: () => void;
  handleBack: () => void;
}

export const Stepper = ({ activeStep, handleBack, handleNext }: StepperProps): JSX.Element => {
  const stepsLength = Object.keys(CommonAreasSteps).length;
  const { spacing, palette } = useTheme();

  return (
    <div>
      <MobileStepper
        steps={stepsLength}
        variant="text"
        position="static"
        activeStep={activeStep}
        style={{ padding: `${spacing(1)} 0`, background: palette.neutral[300] }}
        nextButton={
          <Button height="32px" onClick={handleNext}>
            {activeStep === stepsLength - 1 ? 'CONCLUIR' : 'PRÓXIMO'}
          </Button>
        }
        backButton={
          <Button variant="text" height="32px" color="inherit" onClick={handleBack} disabled={activeStep === 0}>
            ANTERIOR
          </Button>
        }
      />
    </div>
  );
};

export default Stepper;
